module.exports = __webpack_public_path__ + "static/media/GitHubLogo.fbfd5428.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/GitHubLogo.svg
// module id = 420
// module chunks = 0